var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenLeafIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 117.92 122.88",
    style: {
      enableBackground: "new 0 0 117.92 122.88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#89BF3F;} .st1{fill:#4CA71E;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.54,97.85c-5.05,6.71-9.37,12.31-11.71,18.72c-2.29,6.25-3.22,9.12,1.97,2.62 c4.84-6.04,9.37-11.92,15.97-17.47c0.46,0.12,0.97,0.21,1.48,0.32C81.12,113.94,124.7,87.02,117.04,0 C70.96,15.97,5.68,9.47,12.43,91.26C12.69,94.29,12.92,96.37,13.54,97.85L13.54,97.85L13.54,97.85z M27.72,86.1 c15.65-33.71,55.85-45.26,75.79-68.3C81.91,59.92,64.23,61.99,27.72,86.1L27.72,86.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.72,86.1c15.65-33.71,55.85-45.26,75.79-68.3C81.91,59.92,64.23,61.99,27.72,86.1L27.72,86.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenLeafIcon);
export default __webpack_public_path__ + "static/media/green-leaf-icon.76208a01fb45ba0ba4c318a5dcb37ccb.svg";
export { ForwardRef as ReactComponent };